import { LanguageEnum } from '../../../../layout/shared/enum';

export class RoleMenuModel {
	public id: string;
	public channel: string;
	public nameEn: string;
	public nameId: string;
	public nameByLanguage: string;
	public parentId: string;
	public status: string;
	public subMenu: RoleMenuModel[];
	public target: string;
	public level: number;

	public convert(dto: any, level: number = 0): RoleMenuModel {
		this.level = level;

		if (dto.ID) {
			this.id = dto.ID;
		}
		if (dto.channel) {
			this.channel = dto.channel;
		}
		if (dto.nameEN) {
			this.nameEn = dto.nameEN;
		}
		if (dto.nameID) {
			this.nameId = dto.nameID;
		}
		if (dto.parentID) {
			this.parentId = dto.parentID;
		}
		if (dto.status) {
			this.status = dto.status;
		}
		if (dto.subMenu) {
			const nextLevel = this.level + 1;

			this.subMenu = dto.subMenu.reduce((result, each) => {
				result.push(new RoleMenuModel().convert(each, nextLevel));
				return result;
			}, []);
		}
		if (dto.target) {
			this.target = dto.target;
		}

		this.nameByLanguage =
			localStorage.getItem('superAppsBack.lang') === LanguageEnum.English
				? this.nameEn
				: this.nameId;

		return this;
	}
}
